import TriggerModal from './TriggerModal';

export default TriggerModal;
